<template>
  <div class="" >
      <div  v-if="!agregarTutor"> 
          <div  v-if="items.length>0">
            <!-- MUESTRO LOS TUTORES AGREGADOS -->
            <div  v-for="(tutor,index) in items" :key="tutor.dniNumber">
              <div class="my-5 offset-sm-1"></div>
              <div class="col">
                <div class="row row-cols-1 row-cols-sm-2" id="rowppal" >
                  <div class="col-11 col-sm-7 offset-sm-2" >
                    <div class="row row-cols-2 justify-content-end " >
                      <div class="col-1 col-sm-1" style="padding: 0px;text-align: end;">
                            <a style="color:gray;" href="" @click.prevent="deleteTutor(index)" title="Borrar tutor"><i style="font-size:25px" class="zmdi zmdi-close-circle"></i></a>
                      </div>
                      <div class="col-10 col-sm-10 "  >
                        <div class="">
                          <div class=""><h4 style="margin-top:3px!important">{{tutor.lastName +', '+ tutor.name+' '}}</h4>&nbsp; <i>({{tutor.familyRelationshipSelected.name}})</i></div>
                        </div>
                        <div class="">
                          DNI: {{tutor.documentNumber}}, CUIL: {{tutor.cuilNumber}}
                        </div>
                        <div class="">
                          Teléfono: {{tutor.phoneNumber}}
                        </div>
                        <div class="">
                          Email: {{tutor.email}}
                        </div>
                        <div class="">
                          Con domicilio en: {{tutor.street}} {{tutor.streetNumber}} - {{tutor.location}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1 col-sm-5">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="items.length==0" > 
            <h5 style="text-align:center">En este paso podrá agregar uno (obligatorio) o más tutores</h5>
          </div> 
          <div class="my-5 offset-sm-1"></div>
          <div class="row justify-content-center" style="margin-bottom: 5px;">
            <!-- <button v-if="items.length>0" class="btn btn-primary" v-on:click="deleteTutor">Eliminar</button> -->
            <button class="btn btn-primary" v-on:click="addTutor">Agregar tutor</button>
          </div>   
      </div>      

      <div  v-if="agregarTutor" class="col" >
        <form>
          <div class="my-5 offset-sm-1"> <h4>Datos Personales</h4></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1"	>
              <div class="form-group" :class="{ 'form-group--error': $v.item.name.$error }">
                <label for="aspirantName">Nombre/s (según Documento)</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantName"
                  aria-describedby="emailHelp"
                  v-model="item.name"
                />
                  <div class="error" v-if="!$v.item.name.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.name.letters">El nombre no debe contener números.</div>
                  <!-- <div class="has-error" v-if="!$v.item.name.minLength">El nombre debe tener al menos {{$v.item.name.$params.minLength.min}} caracteres.</div> -->
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.lastName.$error }">
                <label for="aspirantLastName">Apellido/s (según Documento)</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantLastName"
                  aria-describedby="emailHelp"
                  v-model="item.lastName"
                />
                  <div class="error" v-if="!$v.item.lastName.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.lastName.letters">El apellido no debe contener números.</div>
              </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.lastName.$error }">
                <div class="fg-line">
                    <label>Relación Familiar:</label>
                    <div class="select">
                        <select v-model="item.familyRelationshipSelected" id="genderCode" name="familyRelationshipSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="relation of familyRelationships" :key="relation.code" :value="relation">{{ relation.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.familyRelationshipSelected.required">Seleccione una opción</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.documentNumber.$error }">
                <label for="aspirantDni">DNI</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantDni"
                  aria-describedby="emailHelp"
                  v-model="item.documentNumber"
                />
                  <div class="error" v-if="!$v.item.documentNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.documentNumber.dni">El campo no debe contener caracteres especiales</div>
                  <div class="error" v-if="!$v.item.documentNumber.minLength || !$v.item.documentNumber.maxLength ">Debe ingresar un DNI válido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.cuilNumber.$error }">
                <label for="aspirantCuil">CUIL</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantCuil"
                  aria-describedby="emailHelp"
                  v-model="item.cuilNumber"
                />
                  <div class="error" v-if="!$v.item.cuilNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.cuilNumber.dni">Debe ingresar el CUIL sin guiones</div>
                  <div class="error" v-if="!$v.item.cuilNumber.minLength || !$v.item.cuilNumber.maxLength ">Debe ingresar un CUIL válido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.birthDate.$error }">
                <label for="aspirantBirthday">Fecha de nacimiento</label>
                <div class="row">
                  <div class="col-md-12">
                    <date-picker v-model="item.birthDate" :config="options"></date-picker>
                  </div>
                </div>
                  <div class="error" v-if="!$v.item.birthDate.required">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.nationalitySelected.$error }">
                  <div class="fg-line">
                      <label>Nacionalidad:</label>
                      <div class="select">
                          <select v-model="item.nationalitySelected" id="countryCode" name="countrySelected" class="form-control"> <!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="citizenship of countries" :key="citizenship.code_iso_alfa3" :value="citizenship">{{ citizenship.citizenship }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.nationalitySelected.required">Campo requerido</div>
                  <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.phoneNumber.$error }">
                <label for="phoneNumber">Teléfono</label>
                <input
                  type="text"
                  class="form-control"
                  id="phoneNumber"
                  aria-describedby="emailHelp"
                  v-model="item.phoneNumber"
                />
                <div class="error" v-if="!$v.item.phoneNumber.required">Campo requerido</div>
                <div class="error" v-if="!$v.item.phoneNumber.phone">Formato de número de teléfono no válido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.email.$error }">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  v-model="item.email"
                />
                <div class="error" v-if="!$v.item.email.required">Campo requerido</div>
                <div class="error" v-if="!$v.item.email.email">Formato de email no válido</div>
              </div>
            </div>
          </div>
          <div class="row">
          </div>

          <!-- ############################ DATOS DE DOMICILIO ACTUAL   ############################# -->
          <div class="my-5 offset-sm-1"> <h4>Domicilio Actual</h4></div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.actualCountrySelected.$error }">
                <div class="fg-line">
                    <label>País actual:</label>
                    <div class="select">
                        <select v-model="item.actualCountrySelected" id="countryCode" @change="getActualProvinces(item.actualCountrySelected)" name="actualCountrySelected" class="form-control"><!-- v-validate="'required'"-->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of actualCountries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.actualCountrySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3 offset-sm-1" >
            <div class="form-group" :class="{ 'form-group--error': $v.item.actualProvinceSelected.$error }">
                <div class="fg-line">
                    <label>Provincia actual:</label>
                    <div class="select">
                        <select v-model="item.actualProvinceSelected" id="ProvinceCode" name="actualProvinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of actualProvinces" :key="province.code_iso" :value="province">{{ province.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.actualProvinceSelected.required">Campo requerido</div>

                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.location.$error }">
                <label for="city">Ciudad</label>
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  aria-describedby="emailHelp"
                  v-model="item.location"
                />
                <div class="error" v-if="!$v.item.location.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.postalCode.$error }">
                <label for="postalCode">Código postal</label>
                <input
                  type="text"
                  class="form-control"
                  id="postalCode"
                  aria-describedby="emailHelp"
                  v-model="item.postalCode"
                />
                <div class="error" v-if="!$v.item.postalCode.required">Campo requerido</div>

              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="neighborhood">Barrio</label>
                <input
                  type="text"
                  class="form-control"
                  id="neighborhood"
                  aria-describedby="emailHelp"
                  v-model="item.neighborhood"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.street.$error }">
                <label for="street">Calle</label>
                  <input
                    type="text"
                    class="form-control"
                    id="street"
                    aria-describedby="emailHelp"
                    v-model="item.street"
                  />
                  <div class="error" v-if="!$v.item.street.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1" :class="{ 'form-group--error': $v.item.streetNumber.$error }">
              <div class="form-group">
                <label for="streetNumber">Número de calle</label>
                <input
                  type="text"
                  class="form-control"
                  id="streetNumber"
                  aria-describedby="emailHelp"
                  v-model="item.streetNumber"
                />
                <div class="error" v-if="!$v.item.streetNumber.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="floorNumber">Piso</label>
                <input
                  type="text"
                  class="form-control"
                  id="floorNumber"
                  aria-describedby="emailHelp"
                  v-model="item.floorNumber"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="department">Departamento</label>
                <input
                  type="text"
                  class="form-control"
                  id="department"
                  aria-describedby="emailHelp"
                  v-model="item.department"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="building">Edificio</label>
                <input
                  type="text"
                  class="form-control"
                  id="building"
                  aria-describedby="emailHelp"
                  v-model="item.building"
                />
              </div>
            </div>
            <div class="col-sm-6 offset-sm-1">
              <div class="form-group">
                <label for="comment">Comentario</label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea" v-model="item.comment"></textarea>
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center" style="margin-bottom: 5px;">
            <button class="btn btn-default col-sm-2 col-4 offset-1" v-on:click="cancelTutor">Cancelar</button> 
            <button class="btn btn-primary col-sm-4 offset-sm-1 col-6" v-on:click="confirmTutor">Confirmar tutor</button>
          </div>
        </form>
      </div>
  <!--   </div> -->
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
import { validationMixin } from 'vuelidate'
import { required, email, minLength,maxLength } from 'vuelidate/lib/validators'
import {letters,dni,phone} from '../../utils/validations'

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        name: '',
        lastName: '',
        documentNumber: '',
        cuilNumber: '',
        familyRelationshipSelected:'',
        birthDate: new Date(),
        nationalitySelected:'',
        countrySelected: '',
        provinceSelected: '',
        location: '',
        postalCode: '',
        neighborhood: '',
        street: '',
        streetNumber: '',
        floorNumber: '',
        department: '',
        building: '',
        actualCountrySelected: '',
        actualProvinceSelected: '',
        comment: '',
        phoneNumber: '',
        email: '',
        profession:''
      },
      items:[],
      agregarTutor:false,
      citizenships: null,
      countries:null,
      actualCountries:null,
      actualProvinces:null,
      familyRelationships:null,
      provinces:null,
      bloodGroups:null,
      bloodFactors:null,
      genders:null,
      options: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        widgetPositioning: {
          vertical: "bottom",
        },
      },
    };
  },
  validations: {
    item: {
      name: {
        required,
        letters
      },
      lastName: {
        required,
        letters
      },
      familyRelationshipSelected:{
        required
      },
      documentNumber:{
        required,
        dni,
        minLength : minLength(7),
        maxLength : maxLength(15)
      },
      cuilNumber:{
        required,
        dni,
        minLength : minLength(11),
        maxLength : maxLength(15)
      },
      birthDate:{
        required
      },
      nationalitySelected:{
        required
      },
      actualCountrySelected:{
        required
      },
      actualProvinceSelected:{
        required
      },
      location: {
        required
      },
      postalCode:{
        required
      },
      street:{
        required
      },
      streetNumber:{
        required
      },
      phoneNumber: {
        required,
        phone
      },
      email:{
        required,
        email
      },      
    }
  },
  computed : {

  },
  created() {
    this.getData();
   // this.getCountries();
    this.getBloodGroups();
    this.getBloodFactors();
    this.getRelations();
  },
  watch: {
    items : function() {
       if ( this.items.length>0) {
          this.$store.commit('setStepTwoData', this.items)
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
    },
    $v: {
/*       handler: function (val) { 
        if ( !val.$invalid) {
          this.$store.commit('setStepTwoData', this.item)
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true, */
    },
    clickedNext(val) {
      if (val === true && this.items.length>0) {
        this.$emit("can-continue", { value: true });
        //this.$v.item.$touch();
      }
    },
    currentStep(){
      if(this.items.length>0)
      this.$emit("can-continue", { value: true });
    }
  },
  mounted() {
    if (this.items.length>0) {
      this.$store.commit('setStepTwoData', this.items)
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods: {
   async getCountries() {
     this.actualCountries=this.countries = (await HTTPFront.get('/getCountries')).data
    },
    getProvinces(countrySelected){
      HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)
      .then(res => {
        this.provinces = res.data;
      })
    },
    getBloodGroups() {
      HTTPFront.get('/getBloodGroups')
      .then(res => {
        this.bloodGroups = res.data;
      })
    },
    getBloodFactors() {
      HTTPFront.get('/getBloodFactors')
      .then(res => {
        this.bloodFactors = res.data;
      })
    },
    getRelations() {
      HTTPFront.get('/getRelations') 
      .then(res => {
        this.familyRelationships = res.data.rows;
      })
    },
    async getData() {
      await this.getCountries();
      this.item.actualCountrySelected = await this.countries.find(country => country.code_iso_alfa3 === 'ARG');
      await this.getActualProvinces(this.item.actualCountrySelected);
      this.item.actualProvinceSelected = await this.actualProvinces.find(province => province.code_iso === 'AR-X'); // (Córdoba)
    },
    async getActualProvinces(countrySelected) {
      this.actualProvinces = (await HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)).data
    },
    addTutor(){
      this.agregarTutor=true;
    },
    confirmTutor(){
      this.items.push(this.item);
      this.item={};
      this.agregarTutor=false;
    },
    cancelTutor(){
      this.item={};
      this.agregarTutor=false;
    },
    deleteTutor(index){
     this.items.splice(index,1);
    }
  }
};
</script>
<style>
.error{
  color:red;
}
</style>